export default __webpack_public_path__ + "static/media/file_tick.b5ad3441.svg";